import '../../sass/blocks/timeline.scss';

(() => {
    const $timelines = document.querySelectorAll('.timeline');

    if (!$timelines) return;

    $timelines.forEach($timeline => {
        const $timelineScroller = $timeline.querySelector('.timeline__timeline');
        const $timelineScrollerContainer = $timeline.querySelector('.timeline__timeline-container');
        const $timelinePositionScrubber = $timeline.querySelector('.timeline__timeline-position-scrubber');

        const $timelineInner = $timeline.querySelector('.timeline__timeline-inner');

        const $fundTimelineGroupsWrap = $timeline.querySelector('.timeline__fund-timeline-groups');
        const $fundTimelineGroups = $timeline.querySelectorAll('.timeline__fund-timeline-group');
        const $timelineCards = $timeline.querySelectorAll('.timeline__timeline-card');

        const setFundTimelinePositions = () => {
            if (!$fundTimelineGroups) return;

            $fundTimelineGroups.forEach($fundTimelineGroup => {
                const year = $fundTimelineGroup?.dataset?.year ? parseInt($fundTimelineGroup.dataset.year) : null;

                if (!year) {
                    $fundTimelineGroup.classList.add('timeline__fund-timeline-group--hide');

                    return;
                }

                const $timelineCardMatch = $timeline.querySelector(`.timeline__timeline-card[data-year="${year}"]`);

                if ($timelineCardMatch) {
                    $fundTimelineGroup.style.left = `${$timelineCardMatch.offsetLeft - $timelineInner.offsetLeft}px`;

                    $fundTimelineGroup.classList.remove('timeline__fund-timeline-group--hide');
                }

                if (!$timelineCardMatch) {
                    let $timelineCardClosestPrev = null;
                    let $timelineCardClosestNext = null;

                    $timelineCards.forEach(($timelineCard, index) => {
                        if ($timelineCardClosestPrev) return;
                        
                        const cardYear = $timelineCard?.dataset?.year ? parseInt($timelineCard.dataset.year) : null;

                        if (!cardYear) return;

                        const $nextCard = $timelineCards?.[index + 1];
                        const nextCardYear = $nextCard?.dataset?.year ? parseInt($nextCard.dataset.year) : null;

                        if (year > cardYear && (!$nextCard || year < nextCardYear)) {
                            $timelineCardClosestPrev = $timelineCard;
                            $timelineCardClosestNext = $nextCard;
                        }
                    });

                    if ($timelineCardClosestPrev) {
                        if ($timelineCardClosestNext) {
                            const $timelineCardClosestPrevInner = $timelineCardClosestPrev.querySelector('.timeline__timeline-card-inner');

                            const timelineCardClosestPrevEndPos = $timelineCardClosestPrev.offsetLeft + $timelineCardClosestPrevInner.offsetWidth;
                            const leftPos = timelineCardClosestPrevEndPos + (($timelineCardClosestNext.offsetLeft - timelineCardClosestPrevEndPos) / 2) - $timelineInner.offsetLeft;

                            $fundTimelineGroup.style.left = `${leftPos}px`;
                        } else {
                            $fundTimelineGroup.style.left = `${$timelineCardClosestPrev.offsetLeft}px`;
                        }

                        $fundTimelineGroup.classList.remove('timeline__fund-timeline-group--hide');
                    }
                }
            });
        };

        const setFundTimelineHeight = () => {
            if (!$fundTimelineGroups || !$fundTimelineGroupsWrap) return;

            let height = 0;

            $fundTimelineGroups.forEach($fundTimelineGroup => {
                const thisHeight = $fundTimelineGroup.offsetHeight;

                if (thisHeight > height) height = thisHeight;
            })

            $fundTimelineGroupsWrap.style.height = `${height}px`;
        };

        const initTimelineScroller = () => {
            if (!$timelineScroller || !$timelineScrollerContainer || !$timelinePositionScrubber) return;

            $timelinePositionScrubber.addEventListener('input', () => {
                $timelineScroller.scrollTo(($timelineScrollerContainer.clientWidth - $timeline.clientWidth) / 100 * $timelinePositionScrubber.value, 0);
            });

            $timelineScroller.addEventListener('scroll', () => {
                $timelinePositionScrubber.value = $timelineScroller.scrollLeft / ($timelineScrollerContainer.clientWidth - $timeline.clientWidth) * 100;

                setFixedTimelineItemPositions();
            });
        };

        const setTimelineInnerMinWidth = () => {
            if (!$timelineInner || !$fundTimelineGroups) return;

            let minWidth = 0;

            $fundTimelineGroups.forEach($fundTimelineGroup => {
                const thisEndPos = $fundTimelineGroup.offsetLeft + $fundTimelineGroup.offsetWidth;

                if (thisEndPos > minWidth) minWidth = thisEndPos;
            });

            $timelineInner.style.minWidth = `${minWidth}px`;
        };

        const setFixedTimelineItemPositions = () => {
            if (!$fundTimelineGroups || !$timelineScroller) return;

            $fundTimelineGroups.forEach(($fundTimelineGroup, index) => {
                const $fundTimelineItems = $fundTimelineGroup.querySelectorAll('.timeline__fund-timeline-item');

                if (!$fundTimelineItems) return;

                const $lastFundTimelineItem = $fundTimelineItems[$fundTimelineItems.length - 1];
                const $nextFundTimelineGroup =  $fundTimelineGroups[index + 1];

                if (!$lastFundTimelineItem) return;

                const leftPos = $lastFundTimelineItem.offsetLeft + $fundTimelineGroup.offsetLeft;

                if (leftPos - $timelineScroller.scrollLeft >= 0) {
                    $lastFundTimelineItem.style.transform = 'translateX(0px)';

                    return;
                }

                if ($nextFundTimelineGroup && $nextFundTimelineGroup.offsetLeft <= $timelineScroller.scrollLeft + $lastFundTimelineItem.offsetWidth) {
                    $lastFundTimelineItem.style.transform = `translateX(${$nextFundTimelineGroup.offsetLeft - $lastFundTimelineItem.offsetWidth - leftPos}px)`;

                    return;
                }

                $lastFundTimelineItem.style.transform = `translateX(${$timelineScroller.scrollLeft - leftPos}px)`;
            });
        };

        window.addEventListener('resize', () => {
            setFundTimelinePositions();
            setFundTimelineHeight();
            setTimelineInnerMinWidth();
            setFixedTimelineItemPositions();
        });

        setFundTimelinePositions();
        setFundTimelineHeight();
        setTimelineInnerMinWidth();
        setFixedTimelineItemPositions();
        initTimelineScroller();
    });
})();
  
